import store from "../store";
import { getUserData } from "../store/persistStore";

const raiseAnalyticsTracking = (eventType, data) => {
  const state = store.getState();
  const isAdobeRefreshEnabled = state.adobe.isAdobeRefreshEnabled;
  if (!isAdobeRefreshEnabled) return;

  console.log(
    "window.eventListenerFrameworkLoaded: " +
      window.eventListenerFrameworkLoaded
  );

  if (window.eventListenerFrameworkLoaded) {
    const event = new CustomEvent(eventType, { detail: data });
    document.dispatchEvent(event);
  } else {
    document.addEventListener("framework-script-loaded", function () {
      const event = new CustomEvent(eventType, { detail: data });
      document.dispatchEvent(event);
    });
  }
};

export const trackAdobeAppClick = ({ action,language }) => {
  const courseLoadData = {
    event: "kickoff-app-click",
    eventInfo: "kickoff-app-click",
    action: "kickoff-app-click",
    languageSelected:language,
    course: {
      courseClick: action || "",
    },
  };

  raiseAnalyticsTracking("pmi-add-tracking", courseLoadData);
};

export const trackAdobePageLoad = ({ courseName, progress,language }, reset = true) => {
  raiseAnalyticsTracking("pmi-reset-tracking", null);
  const userData = getUserData();

  if (userData && userData.id) {
    const loginData = {
      event: "loggedin",
      user: {
        pmiID: userData.id,
      },
    };
    raiseAnalyticsTracking("pmi-add-tracking", loginData);
  }

  if (courseName) {
    const courseLoadData = {
      event: "kickoff-app-load",
      eventInfo: "kickoff-app-load",
      languageSelected:language,
      course: {
        courseName,
        courseProgress: `${courseName}-${progress}%`,
      },
    };

    raiseAnalyticsTracking("pmi-add-tracking", courseLoadData);
  }

  const pageLoadData = {
    event: "pageload",
    eventInfo: "pageload",
    user: {
      loginStatus: userData && userData.id ? "logged-in" : null,
    },
  };

  raiseAnalyticsTracking("pmi-push-tracking", pageLoadData);
};

export const trackAdobeClick = (
  downloadFile = null,
  customLink = null,
  reset = true
) => {
  if (downloadFile) {
    const { fileName, fileLanguage } = downloadFile;
    const customDownloadData = {
      event: "downloads",
      eventInfo: "downloads",
      action: "downloads",
      fileName,
      fileLanguage,
    };
    raiseAnalyticsTracking("pmi-add-tracking", customDownloadData);
  }

  if (customLink) {
    const { linkTitle, linkModule, targetURL } = customLink;
    const customLinkData = {
      event: "linkClick",
      eventInfo: "linkClick",
      link: {
        linkTitle,
        linkModule,
        targetURL,
      },
    };
    raiseAnalyticsTracking("pmi-add-tracking", customLinkData);
  }
};

export const trackAdobeSocialClick = (socialData) => {
  const { socialTool, linkTitle, linkModule, targetURL } = socialData;

  const socialClickData = {
    event: "social-interaction",
    eventInfo: "social-interaction",
    action: "social-interaction",
    socialTool,
  };

  raiseAnalyticsTracking("pmi-add-tracking", socialClickData);

  trackAdobeClick(
    null,
    {
      linkTitle,
      targetURL,
      linkModule,
    },
    false
  );
};

export const trackAdobeAgreeClick = (language) => {
  const agreeLinkData = {
    event: "agree-kickoff",
    eventInfo: "agree-kickoff",
    action: "agree-kickoff",
    languageSelected:language
  };

  raiseAnalyticsTracking("pmi-add-tracking", agreeLinkData);

  trackAdobeClick(
    null,
    {
      linkTitle: "agree",
      targetURL: `${window.location.origin}/app/activity/assessment`,
      linkModule: "terms",
    },
    false
  );
};
